import React from "react";
import TextField from '@material-ui/core/TextField';
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(0.4),
  },
}));

const NomeEmailFormatter = ({ value }) => {
  const classes = useStyles();
  return (<TextField className={classes.root} value={value || ""} InputProps={{ disableUnderline: true }} />)
};

const NomeEmailEditor = ({ value, onValueChange }) => {
  const classes = useStyles();

  function handleChange(event) {
    onValueChange(event.target.value);
  }

  return (
    <div className={classes.root}>
      <TextField
        value={value || ""}
        onChange={handleChange}
        label=""
        variant="standard"
        fullWidth
      />
    </div>
  );
};

export const NomeEmailTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={NomeEmailFormatter}
    editorComponent={NomeEmailEditor}
    {...props}
  />
);
